module.exports = __webpack_public_path__ + "static/media/YB5M01_5.0f33b0e6.jpg";